/* eslint no-underscore-dangle: [2, { "allow": [_id] }] */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { fetchAttachmentDetails, createAttachmentsByProjectID } from '../../../api/api-projects';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CommentContainer } from '../elements-comment/comment-container';
import { ListingImage } from '../elements-image/listing-image';
import { ErrorPage } from '../app-error-page/error-page';
import { injectIntl } from 'react-intl';

class CommentModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      comments: null,
      isError: false,
      commentError: null,
      commentsToShow: null,
      hiddenComments: 0,
      showAllComments: true,
      newComment: false,
      fetchingComments: false
    };

    this.addComment = this.addComment.bind(this);
    this.addCommentCb = this.addCommentCb.bind(this);
    this.getComments = this.getComments.bind(this);
    this.getCommentsCb = this.getCommentsCb.bind(this);
    this.getFullComments = this.getFullComments.bind(this);
    this.renderListingInfo = this.renderListingInfo.bind(this);
    this.renderCommentPanel = this.renderCommentPanel.bind(this);
  }

  componentDidMount () {
    this.getComments();
  }

  getComments () {
    if (!this.state.newComment) {
      this.setState({ fetchingComments: true });
    }
    const attachmentID = this.props.listingAttachment._id;
    const { accessToken } = this.props;
    if (attachmentID) {
      fetchAttachmentDetails(attachmentID, accessToken, this.getCommentsCb);
    }
  }

  getCommentsCb (response) {
    $('#comment').val('');
    if (response.error || 400 < response.statusCode) {
      this.setState({ isError: true });
    } else if (response.comments) {
      const comments = response.comments.reverse();
      const totalComments = comments.length;
      const { newComment, hiddenComments } = this.state;
      const sliceIndex = newComment ? hiddenComments : totalComments - 3;
      this.setState({
        comments,
        commentsToShow: 3 < totalComments ? _.slice(comments, (sliceIndex)) : comments,
        hiddenComments: newComment ? hiddenComments : 3 < totalComments ? (totalComments - 3) : 0,
        fetchingComments: false
      }, () => {
        // add any property that needs to be updated
        this.props.attachmentDetail(response.value, {
          comments: _.get(response, ['comments', 'length'], 0)
        });
      });
    } else {
      this.setState({ fetchingComments: false });
    }
  }

  getFullComments () {
    const { comments, showAllComments } = this.state;
    this.setState({
      commentsToShow: !showAllComments ? _.slice(comments, (comments.length - 3)) : comments,
      hiddenComments: !showAllComments ? comments.length - 3 : 0,
      showAllComments: !showAllComments,
      newComment: false
    });
  }

  addComment (e, callback) {
    const text = $('#comment').val();
    const { accessToken, listingAttachment } = this.props;
    if (accessToken) {
      createAttachmentsByProjectID(listingAttachment.project_id, listingAttachment._id, accessToken, 'COMMENT', this.props.inviteId, text, callback);
    }
  }

  addCommentCb (response) {
    if (response.error || response.err || 400 < response.statusCode) {
      this.setState({
        commentError: this.props.intl.formatMessage({ id: 'boards.comment_modal.something_wrong', defaultMessage: 'Something went wrong. Please try again.' })
      });
    } else {
      const { listingAttachment = {}, index } = this.props;
      const listingID = listingAttachment.listing_id;
      const text = _.get(response, ['attachment', 'data', 'text'], '');
      this.props.votingCommentingAnalytics('board comment submitted (frontend)', listingID, 'commented', index, { character_count: text.length });
      this.setState({ newComment: true }, () => this.getComments());
    }
  }

  renderListingInfo (mobile) {
    const { title, neighborhood, number_guests, images } = this.props.listingAttachment.listing;
    const displayTitle = _.truncate(title, { length: mobile ? 30 : 54, separator: ' ' });
    return (
      <div className="listing-info">
        <div className="d-xs-none d-md-block" style={{ paddingTop: '32px' }}>
          <ListingImage
            imgId={images[0].external_id}
            alt="Peerspace"
            ratio={1.689}
            widths={[512, 768]}
            sizes="122px"
            defaultWidth={1200}
            defaultHeight={495}
          />
        </div>
        <div className="h5" style={{ marginBottom: '6px' }}>{ displayTitle }</div>
        <div className="listing-details">
          { neighborhood }
          <i className="ico ico-md icon-attendees" style={{ paddingLeft: '6px', paddingRight: '2px' }} />
          { number_guests }
        </div>
      </div>
    );
  }

  renderCommentPanel () {
    return (
      <div className="show-comments-container flex-one">
        <CommentContainer
          metaData={[{ colSize: '',
            disabled: false,
            elementID: 'comment',
            hideRequired: true,
            inputFieldName: 'comment',
            optional: false,
            placeholder: this.props.intl.formatMessage({ id: 'boards.comment_modal.add_comment', defaultMessage: 'Add a comment' }),
            ref: 'comment' }]}
          actionFn={this.addComment}
          actionCb={this.addCommentCb}
          disabled={false}
          btnColSize=""
          comments={this.state.comments}
          profileAvatarID={this.props.profile.data.avatar_id}
          getFullComments={this.getFullComments}
          collaborators={this.props.project.collaborators}
          commentsToShow={this.state.commentsToShow}
          hiddenComments={this.state.hiddenComments}
          msgError={this.state.commentError}
          newComment={this.state.newComment}
          spinner={this.state.fetchingComments}
        />
      </div>
    );
  }

  render () {
    const { isError } = this.state;

    if (isError) {
      return (<ErrorPage
        button={this.props.intl.formatMessage({ id: 'boards.comment_modal.error_okay', defaultMessage: 'Okay' })}
        linkFn={this.reloadPage}
        link=""
      />);
    }
    return (
      <BootstrapModal
        {...this.props}
        body={
          <div className='flex'>
            <div className="d-xs-none d-md-block">{this.renderListingInfo()}</div>
            {this.renderCommentPanel(false)}
          </div>
        }
        modalSize="lg-size"
        modalClass="comment-modal"
        onClose={this.props.onClose}
        banner={{
          text: this.renderListingInfo(true),
          type: 'comment-banner'
        }}
        bannerClass="d-sm-none"
      />
    );
  }
}

CommentModal.propTypes = {
  listingAttachment: PropTypes.object,
  accessToken: PropTypes.string,
  profile: PropTypes.object,
  project: PropTypes.object,
  onClose: PropTypes.func
};

exports.CommentModal = injectIntl(CommentModal);
